// extracted by mini-css-extract-plugin
export default {"caseStudyImageContainer":"CaseStudyPrism_caseStudyImageContainer__Tx94b","caseStudyImageWrapper":"CaseStudyPrism_caseStudyImageWrapper__ScdOq","image":"CaseStudyPrism_image__B0LDd"};